import {
  ProgramStatus,
  ProgramTemplatesVm,
} from "@growth-machine-llc/stridist-api-client";
import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";
import { useQueryClient } from "@tanstack/react-query";

import { COACH_PROGRAM_LIBRARY_ASSETS_QUERY_KEY } from "../ProgramsTableScreen";
import ProgramTemplatesService from "../../../services/ProgramTemplatesService";
import { PROGRAM_TEMPLATES_QUERY_KEY } from "../../screen/ProgramTemplatesScreen";

export const useArchiveRestoreProgramTemplateMutation = (
  status: ProgramStatus,
  disableToastAlerts: boolean = false,
) => {
  const mutationFn =
    status === ProgramStatus.PUBLISHED
      ? ProgramTemplatesService.archiveProgramTemplate
      : ProgramTemplatesService.restoreProgramTemplate;

  const statusToInvalidate =
    status === ProgramStatus.PUBLISHED
      ? ProgramStatus.ARCHIVED
      : ProgramStatus.PUBLISHED;

  const queryClient = useQueryClient();

  return useOptimisticUpdateMutation({
    queryKey: [COACH_PROGRAM_LIBRARY_ASSETS_QUERY_KEY, { status }],
    mutationFn: mutationFn,
    disableToastAlerts: disableToastAlerts,
    optimisticUpdater: {
      updateFn: (oldData: ProgramTemplatesVm, id) => {
        return {
          ...oldData,
          totalCount: oldData.totalCount - 1,
          programTemplates: oldData.programTemplates.filter(
            (template) => template.id !== id,
          ),
        } as ProgramTemplatesVm;
      },
    },
    invalidateQueryOptions: {
      enabled: true,
      refetchType: "none",
    },
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [
            COACH_PROGRAM_LIBRARY_ASSETS_QUERY_KEY,
            {
              status: statusToInvalidate,
            },
          ],
        });

        queryClient.invalidateQueries({
          queryKey: [PROGRAM_TEMPLATES_QUERY_KEY],
          exact: false,
        });
      },
    },
  });
};
